import { render } from "./reportSvg.vue?vue&type=template&id=b1de1196&ts=true"
import script from "./reportSvg.vue?vue&type=script&lang=ts"
export * from "./reportSvg.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__